export enum OrderRequisitesVerificationStatus {
  Failed = 'failed',
  Success = 'success',
  InProgress = 'in_progress',
}
